import React, { Component } from 'react';

import { Edit } from 'components/detail';
import { maxLength, SimpleForm } from 'components/form';
import { HiddenInput, NumberInput, SelectInput, TextInput } from 'components/input';
import { connect } from 'react-redux';
import { change as changeAction } from 'redux-form';
import { crudGetList as crudGetListAction } from 'actions/dataActions';
import { DisabledInputOptions, InputOptions, RECORD_FORM, COUNTRY_TH } from 'util/constants';

import * as urls from './urls';
import * as utils from './utils';
import { TextField } from "components/field";


class AppSubscriptionExtendBase extends Component {
  state = {
    'bank_payment': false
  };

  componentDidMount() {
    if (process.env.REACT_APP_COUNTRY !== COUNTRY_TH) {
      this._loadInitProducts();
    }
  }

  _loadInitProducts = () => {
    const { price_type, is_sunmi_shop } = this.props.location;
    let category;
    if(price_type === utils.SUBSCRIPTION_SUNMI) category = utils.POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI;
    else if(price_type === utils.SUBSCRIPTION_NON_SUNMI) category = utils.POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI;
    else {
      if(is_sunmi_shop) category = utils.POS_MALL_CATEGORY_SUBSCRIPTION_SUNMI;
      else category = utils.POS_MALL_CATEGORY_SUBSCRIPTION_NON_SUNMI;
    }
    this.props.crudGetList(
      utils.ProductResourceName,
      urls.productBackendPath,
      {
        category: category,
        enabled: true,
      }
    );
  };

  paymentTypeOnChange = (_, value) => {
    const { price_type, is_sunmi_shop } = this.props.location;
    let category;
    if(price_type === 2) {
      category = utils.SUBSCRIPTION_SUNMI_BANK;
    } else if(price_type === 3) category = utils.SUBSCRIPTION_NON_SUNMI_BANK;
    else {
      if(is_sunmi_shop) category = utils.SUBSCRIPTION_SUNMI_BANK;
      else category = utils.SUBSCRIPTION_NON_SUNMI_BANK;
    }
    this.props.change(RECORD_FORM, 'payment_type', value);
    if (value === utils.PAYMENT_TYPE_BANK) {
      if (process.env.REACT_APP_COUNTRY === COUNTRY_TH) {
        this.props.crudGetList(
          utils.ProductResourceName,
          urls.productBackendPath,
          {
            category: category,
            enabled: true,
          }
        );
      }
      this.props.change(RECORD_FORM, 'reason', utils.EXTENSION_TYPE_BANK);
      this.setState({ 'bank_payment': true });

    } else {
      this._loadInitProducts();
      this.setState({ 'bank_payment': false });
    }
  };

  itemOnChange = (_, value) => {
    const item = this.props.items[value];

    this.props.change(RECORD_FORM, 'unit_price', item.price);
    this.props.change(RECORD_FORM, 'item_name', item.translation);
    this.props.change(RECORD_FORM, 'price_name', item.price_translation);
    this.props.change(RECORD_FORM, 'item_price_id', item.item_price_id);
  };

  render() {
    const { items } = this.props;
    const { bank_payment } = this.state;
    const itemChoices = Object.values(items).sort((a, b) => a['denomination'] - b['denomination']).map(
      item => ({
        id: item.id, name: item.translation
      }));
    return (
      <Edit
        {...this.props}
        editBackendPath={urls.appSubscriptionExtendBackendPath}
        updateDataOnMount={false}
      >
        <SimpleForm>
          <NumberInput
            source='shop_id'
            label='Shop ID'
            isRequired={true}
            options={DisabledInputOptions}
          />
          <TextField
            source='shop_name'
            label='Shop Name'
          />
          <SelectInput
            source='payment_type'
            label='Payment Type'
            choices={utils.PAYMENT_TYPE_CHOICES}
            onChange={this.paymentTypeOnChange}
            isRequired={true}
            options={InputOptions}/>
          <SelectInput
            source='item_id'
            label='Plans'
            choices={itemChoices}
            onChange={this.itemOnChange}
            isRequired={true}
            disabled={!itemChoices.length}
            options={InputOptions}
          />
          <SelectInput
            source='reason'
            label='Reason'
            isRequired={true}
            choices={utils.EXTENSION_CHOICES}
            options={InputOptions}
          />
          <TextInput
            source='bank_name'
            label='Bank Name'
            isRequired={bank_payment}
            options={bank_payment ? InputOptions : DisabledInputOptions}/>
          <TextInput
            source='bank_ref_no'
            label='Bank Ref No'
            isRequired={bank_payment}
            validators={[maxLength(20)]}
            options={bank_payment ? InputOptions : DisabledInputOptions}/>
          <TextInput
            source='comment'
            label='Comment'
            isRequired={true}
            options={InputOptions}/>
          <HiddenInput source='unit_price'/>
          <HiddenInput source='item_name'/>
          <HiddenInput source='price_name'/>
          <HiddenInput source='item_price_id'/>
        </SimpleForm>
      </Edit>
    )
  }
}

const mapStateToProps = (state, props) => {
  const productResourceState = state.admin[utils.ProductResourceName];
  return {
    items: productResourceState.data,
    isLoading: state.admin.loading > 0,
  };
};

export const AppSubscriptionExtend = connect(
  mapStateToProps,
  {
    crudGetList: crudGetListAction,
    change: changeAction,
  }
)(AppSubscriptionExtendBase);



// WEBPACK FOOTER //
// ./src/routes/product/AppSubscriptionExtend.js